import * as logger from './logger';

export default logger;
